import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { replaceByElement } from "../../../../../utils/Logs";

interface IProps {
  benefitPlan: string;
}

export default function FlexVoteIsOver(props: IProps) {
  const { benefitPlan } = props;
  const { t } = useTranslation();

  return useMemo(
    () =>
      replaceByElement(
        t("log.flex_benefit_voting_expired"),
        "{name}",
        benefitPlan
      ),
    [benefitPlan, t]
  );
}
